<div class="step-container">

    <ng-template #labelOne>Seva Profile </ng-template>
    <nb-accordion multi>

        <nb-accordion-item>
            <nb-accordion-item-header>Accommmodations </nb-accordion-item-header>
            <nb-accordion-item-body *ngIf="applicantData?.AccomodationRequest">
                <app-accommodation-details [isPreviewMode]="true"
                    [applicantData]="applicantData.AccomodationRequest"></app-accommodation-details>
            </nb-accordion-item-body>

            <nb-accordion-item-body *ngIf="!applicantData?.AccomodationRequest">
                <div class="no-data-message">
                    <p>No data available for accommodation details.</p>
                </div>
            </nb-accordion-item-body>

        </nb-accordion-item>








        <!-- <nb-accordion-item>
            <nb-accordion-item-header> Skills </nb-accordion-item-header>
            <nb-accordion-item-body *ngIf="applicantData?.VSSkillsData">
                <app-skills [isPreviewMode]="true" [applicantData]="applicantData.VSSkillsData"></app-skills>
            </nb-accordion-item-body>




            <nb-accordion-item-body *ngIf="!applicantData?.VSSkillsData">
                <div class="no-data-message">
                  <p>No data available for accommodation details.</p>
                </div>
        </nb-accordion-item-body>


        </nb-accordion-item> -->

        <nb-accordion-item>
            <nb-accordion-item-header> Practice and Goals </nb-accordion-item-header>
            <nb-accordion-item-body *ngIf="applicantData?.AddendumVS">
                <app-contemplation [isPreviewMode]="true"
                    [applicantData]="applicantData.AddendumVS"></app-contemplation>
            </nb-accordion-item-body>


            <nb-accordion-item-body *ngIf="!applicantData?.AddendumVS">
                <div class="no-data-message">
                    <p>No data available for accommodation details.</p>
                </div>
            </nb-accordion-item-body>




        </nb-accordion-item>

        <nb-accordion-item>
            <nb-accordion-item-header> Your dates of availability for offering </nb-accordion-item-header>
            <nb-accordion-item-body *ngIf="applicantData?.ArrivalSchedule">
                <app-tentative-date [isPreviewMode]="true"
                    [applicantData]="applicantData.ArrivalSchedule"></app-tentative-date>
            </nb-accordion-item-body>


            <nb-accordion-item-body *ngIf="!applicantData?.ArrivalSchedule">
                <div class="no-data-message">
                    <p>No data available for Requested Dates details.</p>
                </div>
            </nb-accordion-item-body>


        </nb-accordion-item>

    </nb-accordion>
</div>